const companyIdTokenStore = () => {
  let instance;

  return {
    set: (token) => {
      instance = token;
      return instance;
    },
    get: () => instance,
  };
};

export default companyIdTokenStore;
